import VerifiedIcon from '@mui/icons-material/Verified';

export const VerifiedBadge = () => {
    return (
        <span className="badge rounded-pill text-bg-info m-1" title="Verified Content Creator">
            <VerifiedIcon />
        </span>
    )
}